export default __webpack_public_path__ + "static/media/Rectangle163@2x.ca118385.png";